export default {
  "hierarchy": {
    "perPage": [
      "textInput-perPage"
    ],
    "formInput": [
      "textInput-inputGrow",
      "textInput-formInput"
    ],
    "attributeTableStringEditor": [
      "textInput-attributeTableStringEditor"
    ],
    "password": [
      "textInput-password"
    ],
    "inputGrow": [
      "textInput-inputGrow"
    ],
    "multiSelector": [
      "textInput-multiSelector"
    ],
    "small": [
      "textInput-small"
    ],
    "attributeStringEditor": [
      "textInput-attributeStringEditor"
    ],
    "attributeEditor": [
      "textInput-attributeEditor"
    ],
    "comparator": [
      "textInput-comparator"
    ],
    "imageUrlInput": [
      "textInput-inputGrow",
      "textInput-imageUrlInput"
    ],
    "customTextValueEditor": [
      "textInput-customTextValueEditor"
    ],
    "attributeDetailIntEditor": [
      "textInput-attributeTableStringEditor",
      "textInput-attributeIntEditor",
      "textInput-attributeDetailIntEditor"
    ],
    "attributeDetailStringEditor": [
      "textInput-attributeTableStringEditor",
      "textInput-attributeDetailStringEditor"
    ],
    "attributeTableGeoPointEditor": [
      "textInput-attributeTableGeoPointEditor"
    ],
    "attributeDetailGeoPointEditor": [
      "textInput-attributeTableGeoPointEditor",
      "textInput-attributeDetailGeoPointEditor"
    ],
    "attributeDetailPercentEditor": [
      "textInput-attributeDetailPercentEditor"
    ],
    "attributeIntEditor": [
      "textInput-attributeTableStringEditor",
      "textInput-attributeIntEditor"
    ],
    "attributeTablePercentEditor": [
      "textInput-attributeTablePercentEditor"
    ],
    "attributeDetailEditor": [
      "textInput-attributeEditor",
      "textInput-attributeDetailEditor"
    ],
    "attributeFormIntEditor": [
      "textInput-attributeFormEditor",
      "textInput-attributeFormIntEditor"
    ],
    "attributeFormEditor": [
      "textInput-attributeFormEditor"
    ],
    "attributeFormStringArrayEditor": [
      "textInput-attributeFormEditor",
      "textInput-attributeFormStringArrayEditor"
    ],
    "limit": [
      "textInput-limit"
    ],
    "inputGrowRounded": [
      "textInput-inputGrow",
      "textInput-inputGrowRounded"
    ],
    "attrKey": [
      "textInput-attrKey"
    ]
  },
  "props": {
    "default": {
      "icon": ""
    },
    "perPage": {
      "icon": ""
    },
    "formInput": {
      "icon": ""
    },
    "attributeTableStringEditor": {
      "icon": ""
    },
    "password": {
      "icon": "",
      "hidePasswordIcon": "fa fa-eye-slash fa-fw",
      "showPasswordIcon": "fa fa-eye fa-fw"
    },
    "inputGrow": {
      "icon": ""
    },
    "multiSelector": {
      "icon": ""
    },
    "small": {
      "icon": ""
    },
    "attributeStringEditor": {
      "icon": ""
    },
    "attributeEditor": {
      "icon": ""
    },
    "comparator": {
      "icon": ""
    },
    "imageUrlInput": {
      "icon": ""
    },
    "customTextValueEditor": {
      "icon": ""
    },
    "attributeDetailIntEditor": {
      "icon": ""
    },
    "attributeDetailStringEditor": {
      "icon": ""
    },
    "attributeTableGeoPointEditor": {
      "icon": ""
    },
    "attributeDetailGeoPointEditor": {
      "icon": ""
    },
    "attributeDetailPercentEditor": {
      "icon": ""
    },
    "attributeIntEditor": {
      "icon": ""
    },
    "attributeTablePercentEditor": {
      "icon": ""
    },
    "attributeDetailEditor": {
      "icon": ""
    },
    "attributeFormIntEditor": {
      "icon": ""
    },
    "attributeFormEditor": {
      "icon": ""
    },
    "attributeFormStringArrayEditor": {
      "icon": ""
    },
    "limit": {
      "icon": ""
    },
    "inputGrowRounded": {
      "icon": ""
    },
    "attrKey": {
      "icon": ""
    }
  }
}